import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;

// For fetching the record of Conversation Service.
export const getConversation = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chats/Conversation`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // For fetching the record of Chats Service.
export const getChats = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Message/Chats?LoggedinUserId=${params.LoggedinUserId}`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

// For posting the record of Chats Service.
export const postChats = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Message/Send`, params, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

  // For Delete the goup and exit member.
export const messageDelete = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Delete`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
  // For Delete the exiting group member.
  export const groupMemberDelete = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Member/Delete`, params, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

export const postCreateGroup = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
//Update request of the mark as Read.
export const markAsRead = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Read`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
//Update request of the mark as Read all .
export const markAsReadAll = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/ReadAll`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
//Add request of the Group member.
export const addGroupMember = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Member/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
//Add request of the Group member.
export const groupDetail = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/GetGroupInfo`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}

//Change the request of Add Group Admin.
export const makeGroupMemberAdmin = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Member/MarkAdmin`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}

//Change the request of Add Group Admin.
export const deleteGroupChatData = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Delete`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}

//Change the request of Add Group Admin.
export const deleteChatData = async (params) => {
  try {
      const response = await axiosInstance.post(`${baseURL}/Message/Chat/Delete`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
}
//Recover the Group
export async function RecoverGroupManage(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/UnDelete`,params,{
    headers: await getHeaders(),
    body: JSON.stringify(params),
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
 
}

// Change Owner of the group

export async function UpdateOwner(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Message/Group/UpdateOwner`,params,{
    headers: await getHeaders(),
    body: JSON.stringify(params),
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
 
}

// GroupInfo of the group


export async function getGroupManage(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Message/Group/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }    
}
  

export const getGroupArchieved = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Message/Chat/Group/Archive?GroupId=${params.GroupId}`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }